import React, { Component } from 'react'
import { Table, Tag, message, Popconfirm, Checkbox, Button } from 'antd';
import { FirebaseRef } from '../../lib/firebase'
import serviceMail from '../../services/sendmail'

import { EditableCell, EditableFormRow } from './../../components/CustomerTable'

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      loading: false,
      visibleSignUp: false,
      action: false,
      status: 'pending'
    }
  }

  componentDidMount() {
    this.setState({
      loading: true
    })
    let ref = FirebaseRef.child(`/app`)
    ref.on('value', snapshot => {
      const data = snapshot.val()
      if (data && typeof (data) === 'object') {
        let newData = []
        Object.keys(data).forEach(key => {
          if (data[key]) {
            newData.push({
              ...data[key],
              id: key,
            })
          }
        })
        const newArray = newData.reverse()

        this.setState({
          data: newArray

        })
      }
      this.setState({
        loading: false
      })
    })
  }

  handleSendMail(Subject, Message, from, to) {
    const data = {
      from,
      to,
      subject: Subject,
      html: Message
    }
    serviceMail.sendMail(data).then(() => {
    })
  }

  confirm(id) {
    const ref = FirebaseRef.child(`/app/${id}`)

    ref.remove().then(() => {
      message.success("Notify was removed!")

    }).catch(err => {
      message.error(err)
    })
  }

  handleSave = row => {

    const ref = FirebaseRef.child(`/app/${row.id}`)
    ref.set({
      ...row
    })


  };

  render() {

    const columns = [
      {
        title: 'Icon',
        dataIndex: 'img',
        key: 'img',
        render: (text, record) => <>

          <img alt="img" style={{ width: '100px', height: '100px' }} src={record.app_img ? record.app_img : `/assets/img/no_Image.png`} />
        </>,
      },
      {
        title: 'Name',
        dataIndex: 'title',
        key: 'title',
        render: text => <>
          {text}
        </>,
      },

      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Desktop',
        dataIndex: 'pupolar',
        key: 'pupolar',
        editable: true,
        render: (_, record) => <>
          <Checkbox checked={record.desktop} />
        </>,
      },
      {
        title: 'Ios',
        dataIndex: 'hot',
        key: 'hot',
        editable: true,
        render: (_, record) => <>
          <Checkbox checked={record.ios} />
        </>,
      },
      {
        title: 'Android',
        dataIndex: 'android',
        key: 'android',
        editable: true,
        render: (_, record) => <>
          <Checkbox checked={record.android} />
        </>,
      },
      {
        title: 'Action',
        key: 'action',
        render: (text, record) => (
          <span style={{ display: "flex", }}>
            <Popconfirm placement="top" title={"Are you sure you will delete this application?"} onConfirm={() => { this.confirm(record.id) }} okText="Yes" cancelText="No">
              <Tag color={"red"} key={"delete"}>
                Delete
                </Tag>
            </Popconfirm>

            <Tag onClick={() => {
              this.props.history.push(`/manage/${record.id}/applications`)

            }} color={"blue"} key={"edit"}>
              Edit
             </Tag>

            <Tag
              onClick={() => {
                const ref = FirebaseRef.child(`/app/${record.id}`)
                const newData = {
                  ...record,
                  app_ids: [],
                  status: "pendding"
                }


                ref.set({ ...newData }).then(() => {

                  message.success("Send notify app to user successfully")
                })
              }}
              color={"rgb(254, 140, 0)"}
              key={"notication"}>
              Send Notify
            </Tag>


          </span >
        ),
      },
    ];

    const { data, loading } = this.state


    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };

    const newColumns = columns.map(col => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: (record) => { this.handleSave(record) },
        }),
      };
    });

    return (
      <div >
        <div style={{ textAlign: "right", width: "100%", marginBottom: "15px" }}>
          <Button onClick={() => { this.props.history.push("/manage/applications/add") }} type="primary" >
            Add App
          </Button>
        </div>

        <Table rowClassName={() => 'editable-row'} components={components} loading={loading} columns={newColumns} dataSource={data} />

      </div>
    )
  }

}
export default Home;
